module.exports = __webpack_public_path__ + "static/cover-7ab292e459259c1894bbdba203e3df6f.mp4";